import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { ChatComponent, SplitPaneComponent } from '@components';
import { SplitPaneVerticalComponent, HistoryComponent } from '@components';

interface ProjectDeliveryDraft {
  milestone: string;
  owner: string;
  status: string;
  riskNotes: string;
}

@Component({
  selector: 'app-project',
  templateUrl: './project.page.html',
  styleUrls: ['./project.page.scss'],
  standalone: true,
  imports: [
    RouterModule,
    FormsModule,
    ChatComponent,
    HistoryComponent,
    SplitPaneComponent,
    SplitPaneVerticalComponent
],
})
export class ProjectPage {
  public projectSuggestions: any[] = [
    { icon: 'bi bi-kanban', prompt: 'Show milestones and progress' },
    { icon: 'bi bi-flag', prompt: 'List current risks and owners' },
    { icon: 'bi bi-diagram-3', prompt: 'Summarize dependencies' },
  ];

  public projectContext: any = {
    page: 'project',
    purpose: 'Provide project overview: milestones, risks, dependencies',
    milestones: [],
    risks: [],
    dependencies: [],
    outputs: ['Milestone status', 'Risk register', 'Dependency map']
  };

  public evaluatingState = false;
  public projectError = '';
  public projectSuccess = '';
  public hasEvaluatedState = false;
  public projectDraft: ProjectDeliveryDraft = {
    milestone: '',
    owner: '',
    status: '',
    riskNotes: '',
  };

  public readonly statusOptions = ['On track', 'At risk', 'Blocked'];

  constructor() {}

  public async evaluateProjectState(): Promise<void> {
    this.projectError = '';
    this.projectSuccess = '';
    this.hasEvaluatedState = false;

    if (!this.projectDraft.milestone.trim()) {
      this.projectError = 'Enter a milestone before evaluating project state.';
      return;
    }
    if (!this.projectDraft.owner.trim()) {
      this.projectError = 'Enter an owner before evaluating project state.';
      return;
    }
    if (!this.projectDraft.status.trim()) {
      this.projectError = 'Select a status before evaluating project state.';
      return;
    }

    this.evaluatingState = true;
    try {
      await new Promise((resolve) => setTimeout(resolve, 700));
      this.hasEvaluatedState = true;
      this.projectSuccess = 'Project state evaluation generated.';
    } finally {
      this.evaluatingState = false;
    }
  }
} 